import React from "react";
import "./common.scss";

const InlineLoader = ({ label = "Loading…" }) => (
  <div className="inline-loader">
    <i className="ti ti-loader-2"></i>
    <div className="inline-loader-label">{label}</div>
  </div>
);

export default InlineLoader;